import type { Character } from "./types/character";
import { ALL_CHARACTERS } from "./types/character";
import type { GameConfig } from "./types/config";
import type { HorrorRaceState } from "./types/game-state";
import type { Player } from "./types/player";
import { validatePlayerCount } from "./utils/player-count-rules";
import { createInitialTurnOrder } from "./utils/turn-order";

export interface InitGameOptions {
  readonly config: GameConfig;
  readonly playerIds: readonly string[];
  readonly playerNames: readonly string[];
  readonly hostPlayerId: string;
}

function createPlayer(id: string, name: string): Player {
  return {
    id,
    name,
    hand: [...ALL_CHARACTERS],
    secretSelection: null,
    hasRevealed: false,
    hasConfirmedRecap: false,
    hasConfirmedRoundRecap: false,
  };
}

function createInitialPositions(): Readonly<Record<Character, number>> {
  return {
    VAMPIRE: 0,
    JIANGSHI: 0,
    GUMIHO: 0,
    MUMMY: 0,
    ZOMBIE: 0,
  };
}

function createInitialGarnets(
  playerIds: readonly string[],
): Readonly<Record<string, number>> {
  const garnets: Record<string, number> = {};
  for (const id of playerIds) {
    garnets[id] = 0;
  }
  return garnets;
}

export function initGame(options: InitGameOptions): HorrorRaceState {
  const { config, playerIds, playerNames, hostPlayerId } = options;
  validatePlayerCount(config.playerCount);

  const players = playerIds.map((id, i) => createPlayer(id, playerNames[i]));

  return {
    phase: "SETUP_CHARACTER_SELECTION",
    config,
    raceNumber: 1,
    round: 1,
    players,
    turnOrder: createInitialTurnOrder(config.playerCount),
    currentTurnIndex: 0,
    drawPass: 1,
    characterPositions: createInitialPositions(),
    coinPool: [],
    drawnCoins: [],
    zones: { 1: [], 2: [], 4: [] },
    forfeitPlayerIndex: null,
    hasForfeitThisRound: false,
    raceResults: [],
    garnets: createInitialGarnets(playerIds),
    selectionsComplete: 0,
    hostPlayerId,
    roundResolution: null,
    currentRaceDrawHistory: [],
  };
}
